import React, { Component } from 'react'

import ImageCardItem from './ImageCardItem'
import CardListHeader from '../../common/list/v1/CardListHeader'
import _ from 'lib/lodash'

import './ImageCardList.css'

class ImageCardList extends Component {
	/*shouldComponentUpdate(nextProps, nextState) {
		//const { actionHandler } = this.props;

		//console.log('should?')
		/* re-render only if number of nodes has changed */
		//return !_.isEqual(nextProps.nodes, this.props.nodes);
		//return true;
	//}

	render() {
		//console.log('ImageCardList: render')
		const { actionHandler, aclAllow, title } = this.props;

		// filter nodes with valid storage information
		const nodes = _.pickBy(this.props.nodes, (node, key) => node.hasOwnProperty('storage'));

		// filter for valid storage entries and reverse nodes to have newest on top
		const renderCards = () => _.map(nodes, (node, key) => (
			<ImageCardItem node={node} key={key} actionHandler={actionHandler} aclAllow={aclAllow}/>)
		).reverse();

		return (
			<section>
				<CardListHeader
					nodes={nodes}
					actionHandler={actionHandler}
					title={title}
					titleOne="Bild"
					titleMany="Bilder"
					aclAllow={aclAllow}
				/>
				<div className="md-list-unstyled image-card-list-items">
					{renderCards()}
				</div>
			</section>
		);
	}
}

export default ImageCardList;



// WEBPACK FOOTER //
// ./src/components/cards/image/v1/ImageCardList.jsx